import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-download-premium',
    templateUrl: './download-premium.component.html',
    styleUrls: ['./download-premium.component.scss'],
    standalone: false
})
export class DownloadPremiumComponent implements OnInit {
  isLoaded: boolean = true;
  isLegacyDownload: boolean = false;
  @Output() exportExcel = new EventEmitter<any>();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  onDownload(): void {
    this.activeModal.close();
    this.exportExcel.emit(this.isLegacyDownload);
  }
}
